
(function (module) {
    "use strict";

    module.component('selectionForecast', {
        template: require('./selectionForecastComponent.html'),
        bindings: {
            parameters: '<',
            stepEnter: "=",
            market: "<",
            brands: "=",
            selectedBrand:"="            
        },
        controller: [function(this: $TSFixMe) {
            var $ctrl = this;
        }]
    })

})(angular.module('topline.modules'));